import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface ContainerProps extends ComponentPropsWithRef<"div"> {
  /** Largeur maximale prédéfinie du conteneur. Par défaut "xl" (1280px). */
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full";
  /** Centre horizontalement le conteneur. Par défaut true. */
  centered?: boolean;
  /** Active les rembourrages latéraux réactifs (px-4 sm:px-6 lg:px-8). Par défaut true. */
  gutter?: boolean;
  children?: ReactNode;
}

const SIZE_CLASSES = {
  sm: "max-w-screen-sm", // 640px
  md: "max-w-screen-md", // 768px
  lg: "max-w-screen-lg", // 1024px
  xl: "max-w-screen-xl", // 1280px
  "2xl": "max-w-screen-2xl", // 1536px
  full: "max-w-full",
} as const;

/**
 * Conteneur réactif SOTA et neutre.
 * Aligne et limite la largeur du contenu de manière cohérente sur mobile, tablette et desktop.
 */
export function Container({
  className,
  size = "xl",
  centered = true,
  gutter = true,
  children,
  ...props
}: ContainerProps) {
  return (
    <div
      className={cn(
        "w-full",
        SIZE_CLASSES[size],
        centered && "mx-auto",
        gutter && "px-4 sm:px-6 lg:px-8",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
